<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/produto-materiais/datatable/'+$route.params.id"
            actionFild
            @update="update"
            @destroy="destroy"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
	data(){
		return {
            dados: [],
            columns: [
                {
                    label: 'Nome',
                    field: 'nome',
                    order: 'produto_materiais.nome',
                    sort: 'asc'
                },
                {
                    label: 'Valor',
                    field: 'valor_br',
                    order: 'produto_materiais.valor',
                    sort: 'asc'
                },
                {
                    label: 'Quantidade de produtos',
                    field: 'quantidade_produtos',
                    order: 'produto_materiais.quantidade_produtos',
                    sort: 'asc'
                },
                {
                    label: 'Custo por produto',
                    field: 'valor_por_produto_br',
                    order: 'produto_materiais.valor_por_produto',
                    sort: 'asc'
                },
            ],
            buttons: [
                {
                    action: 'update',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-edit'
                },
                {
                    action: 'destroy',
                    classe: 'btn btn-danger',
                    iconClass: 'fas fa-trash'
                },
            ]
    	}
	},
    methods: {
        update(dado){
            this.$emit('update', dado.id);
        },
        destroy(dado){
            this.$emit('destroy', dado.id);
        },
    }
}
</script>